import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonBeginCheckout() {
  function reportBeginCheckout(
    productId: string | number,
    itemName: 'Coins Package' | 'Membership',
    price: string | number,
  ) {
    pushAxonEvent('begin_checkout', {
      currency: 'USD',
      value: Number(price),
      items: [buildAxonItem(productId, itemName, price)],
    })
  }

  return { reportBeginCheckout }
}
